import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Ritual from "@/pages/Ritual";
import ShapeUp from "@/pages/ShapeUp";
import Faith from "@/pages/Faith";
import Library from "@/pages/Library";
import ContentDetail from "@/pages/ContentDetail";
import Membership from "@/pages/Membership";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AIAssistant from "@/pages/AIAssistant";
import Coaching from "@/pages/Coaching";
import Care from "@/pages/Care";
import Programs from "@/pages/Programs";
import Apply from "@/pages/Apply";
import Masterclass from "@/pages/Masterclass";
import BloomBlueprintSession from "@/pages/BloomBlueprintSession";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  // Process OAuth session_id FIRST (synchronously during render) to avoid race conditions.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Auth mode="login" />} />
      <Route path="/signup" element={<Auth mode="signup" />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/apply/:type" element={<Apply />} />
      <Route path="/masterclass" element={<Masterclass />} />
      <Route path="/bloom-blueprint-session" element={<BloomBlueprintSession />} />
      <Route path="/membership" element={<ProtectedRoute><Membership /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute requireMember><Dashboard /></ProtectedRoute>} />
      <Route path="/ritual" element={<ProtectedRoute requireMember><Ritual /></ProtectedRoute>} />
      <Route path="/shapeup" element={<ProtectedRoute requireMember><ShapeUp /></ProtectedRoute>} />
      <Route path="/faith" element={<ProtectedRoute requireMember><Faith /></ProtectedRoute>} />
      <Route path="/library" element={<ProtectedRoute requireMember><Library /></ProtectedRoute>} />
      <Route path="/library/:id" element={<ProtectedRoute requireMember><ContentDetail /></ProtectedRoute>} />
      <Route path="/assistant" element={<ProtectedRoute requireMember><AIAssistant /></ProtectedRoute>} />
      <Route path="/coaching" element={<ProtectedRoute requireMember><Coaching /></ProtectedRoute>} />
      <Route path="/care" element={<ProtectedRoute requireMember><Care /></ProtectedRoute>} />
      <Route path="/programs" element={<ProtectedRoute requireMember><Programs /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
